export type CacheEntry<T> = {
  timestamp: number;
  data: Promise<T>;
};

const cache = new Map<string, CacheEntry<any>>();
const TTL = 5 * 60 * 1000; // 5 min

export const cachedGet = <T>(key: string, fetcher: () => Promise<T>): Promise<T> => {
  const entry = cache.get(key);

  if (entry && Date.now() - entry.timestamp < TTL) {
    return entry.data;
  }

  const promise = fetcher();
  cache.set(key, { timestamp: Date.now(), data: promise });

  return promise;
};

export const clearCache = (key?: string) => {
  if (key) {
    cache.delete(key);
  } else {
    cache.clear();
  }
};
